"use client";
import styled from "styled-components";
import { Col } from "react-bootstrap";
import { Img } from "@/components/Img";
import Title from "@/components/Title";
import TitleSerial from "@/components/TitleSerial";
import { Black } from "@/styles/globalStyleVars";
import ThemeRow from "@/components/theme/row";
import reactHtmlParser from "react-html-parser";

const Component = ({ data, sectionId }) => {
  return (
    <StyledComponent
      id={`${sectionId ? sectionId : ""}`}
      className="benefits pt-200 pb-120"
    >
      {data?.bg_img && <Img objectFit={"cover"} src={data?.bg_img} />}

      <ThemeRow>
        <Col sm={5} className={'d-flex align-items-center justify-content-around'}>
          <TitleSerial line text={"II"}/>
          {data?.section_name && (
            <Title
              background={"#191919"}
              number={"II"}
              text={data?.section_name}
            />
          )}
        </Col>

        <Col sm={6}>
          {/*<TitleSerial text={"II"} />*/}
        </Col>

        <Col sm={{ span: 4, offset: 1 }} className={"benefits__items-row"}>
          {data?.mission_title && (
            <ul className={"mission-title fade-up"}>
              <li>
                <h5>{data?.mission_title}</h5>
              </li>
            </ul>
          )}

          <div className="mission-description fade-up">
            {data?.mission_description &&
              reactHtmlParser(data?.mission_description)}
          </div>
        </Col>
        <Col sm={{ span: 4, offset: 1 }} className={"benefits__items-row"}>
          {data?.vision_title && (
            <ul className={"vision-title fade-up"}>
              <li>
                <h5 className={"split-up"}>{data?.vision_title}</h5>
              </li>
            </ul>
          )}

          <div className="mission-description fade-up">
            {data?.mission_description &&
              reactHtmlParser(data?.vision_description)}
          </div>
        </Col>
      </ThemeRow>
    </StyledComponent>
  );
};

const StyledComponent = styled.div`
  overflow: hidden;
  position: relative;
  background: #f4f4f4;

  .title-number{
    padding-right: 5px;
  }
  img {
    //opacity: .05;
  }

  h4 {
    font-size: 120px;
    line-height: 120px;
    font-weight: 600;
    margin-top: 80px;

    span {
      display: block;
      width: 63%;
      margin-left: auto;
    }
  }

  .benefits__items-row {
    margin-top: 80px;

    .vision-title {
      li {
        position: relative;
        counter-increment: count;
        padding-left: 30px;

        &:before {
          content: "B";
          position: absolute;
          height: 18px;
          width: 18px;
          padding: 0;
          background: ${Black};
          border-radius: 50%;
          color: white;
          top: 7px;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
        }
      }
    }

    .mission-title {
      li {
        position: relative;
        counter-increment: count;
        padding-left: 30px;

        &:before {
          content: "A";
          position: absolute;
          height: 18px;
          width: 18px;
          padding: 0;
          background: ${Black};
          border-radius: 50%;
          color: white;
          top: 7px;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
        }
      }
    }
    h5 {
      font-size: 20px;
      line-height: 28px;
      color: ${Black};
      font-weight: 500;
      margin-bottom: 30px;
    }
    .mission-description {
      ul {
        li {
          padding: 15px 0;
          border-bottom: 1px solid rgba(25, 25, 25, 0.2);
          font-size: 16px;
          line-height: 20px;

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }

  @media (max-width: 992px) {
    .benefits__items-row {
      max-width: 100% !important;
      flex: 0 0 100%;
      margin: 0;
    }
  }
`;
export default Component;
